import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EnovacomState } from '../../entities';
import * as fromEnovacom from '../reducers/enovacom.reducer';

export const selectEnovacomState = createFeatureSelector<EnovacomState>(fromEnovacom.enovacomFeatureKey);

export const selectEnovacomTokenLoading = createSelector(selectEnovacomState, state => state.isTokenLoading);
export const selectEnovacomToken = createSelector(selectEnovacomState, state => state.token);
